import styled, { css } from 'styled-components';
import { media, layout } from 'src/components/base';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import ExpertAvatarComponent from './components/expert-avatar';

export const AVATAR_SIZE = 32;

export const CardTitle = styled(TitleMediumText)`
  a {
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;

  ${media.mediumDown`
    grid-template-columns: minmax(0, 1fr);
  `};
`;

export const Main = styled.main``;

export const Article = styled.article`
  padding: ${layout.measurements.spacing100};
  padding-top: 0;
`;

export const Item = styled.div`
  padding: 0 ${layout.measurements.spacing100};
`;

type SidebarProps = {
  viewport?: 'mobile' | 'desktop';
};

export const Title = styled(TitleMediumText)`
  &&,
  > * {
    font-size: ${layout.measurements.fontSizeMedium};
    font-weight: 700;
  }
`;

export const Sidebar = styled.aside<SidebarProps>(
  p => css`
    display: flex;
    flex-direction: column;
    padding: 0 ${layout.measurements.spacing050};
    flex-shrink: 0;

    ${media.mediumDown`
      padding: 0;

      ${
        p.viewport === 'desktop' &&
        css`
          display: none;
        `
      }
    `};

    ${media.largeUp`
      padding-right: ${layout.measurements.spacing100};

      ${
        p.viewport === 'mobile' &&
        css`
          display: none;
        `
      }
    `};
  `
);

export const Header = styled.header`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-auto-flow: row;
  padding: ${layout.measurements.spacing100} 0;
  row-gap: ${layout.measurements.spacing050};
  height: max-content;

  h1 {
    margin: 0;
  }

  ${media.mediumDown`
    padding-bottom: ${layout.measurements.spacing050};
  `}
`;

type ContentProps = {
  order?: number;
  rowGap?: typeof layout.measurements[keyof typeof layout.measurements];
  fontSize?: typeof layout.measurements[keyof typeof layout.measurements];
  marginTop?: typeof layout.measurements[keyof typeof layout.measurements] | 0;
};

export const Content = styled.div<ContentProps>(
  p => css`
    font-size: ${p.fontSize || layout.measurements.fontSizeMedium};
    display: grid;
    grid-auto-flow: row;
    row-gap: ${p.rowGap || layout.measurements.spacing050};
    order: 2;
    margin-top: ${p.marginTop ?? layout.measurements.spacing100};

    a:not([class]) {
      color: ${p.theme.text.callToAction};

      &:hover {
        color: ${p.theme.text.callToActionHover};
        text-decoration: underline;
      }
    }

    ${media.mediumDown`
      order: ${p.order || 2};

      &:not(:first-of-type) {
        margin-top: ${layout.measurements.spacing200};
      }
    `};

    > h2,
    > h3,
    > *:last-child {
      margin-bottom: 0;
    }
  `
);

export const Info = styled.span`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  column-gap: ${layout.measurements.spacing050};
`;

export const Subtitle = styled(TitleMediumText)``;

type MediaWrapperProps = {
  maxWidth?: number;
};

export const MediaWrapper = styled.div<MediaWrapperProps>(
  props => css`
    ${props.maxWidth &&
    css`
      max-width: ${props.maxWidth}px;
    `}
  `
);

export const Media = styled.div`
  width: 100%;
`;

export const MediaImage = styled.img`
  border-radius: 16px;

  ${media.smallOnly`
      border-radius: 8px;
  `}
`;

export const ContentType = styled.div`
  font-size: ${layout.measurements.fontSizeSmall};
  color: ${p => p.theme.text.secondary};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`;

export const ExpertAvatar = styled(ExpertAvatarComponent)`
  grid-area: 1 / 1 / 4 / 2;
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-bottom: 1px solid ${p => p.theme.colors.base200};
  margin: ${layout.measurements.spacing300} 0;

  ${media.mediumDown`
    margin: ${layout.measurements.spacing200} 0;
  `}
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-x: auto;
  padding: 2px;

  > button {
    flex-shrink: 0;
    margin-bottom: ${layout.measurements.spacing050};

    :not(:last-child) {
      margin-right: ${layout.measurements.spacing050};
    }
  }
`;
